import React from 'react';
import { ChevronRight } from 'lucide-react';

const ProjectCard = ({ project, onClick }) => (
  <div 
    className="project-card"
    onClick={() => onClick(project)}
  >
    <div className="project-header">
      <div>
        <h3 className="project-title">{project.title}</h3>
        <p className="project-subtitle">{project.subtitle}</p>
        {project.description && project.description.trim() !== '' && (
          <p className="project-subtitle">{project.description}</p>
        )}
      </div>
      <div className={`${project.id}-card-animation`}>
      </div>
      <ChevronRight className="chevron" size={32} />
    </div>
  </div>
);

export default ProjectCard;